module.exports = __webpack_public_path__ + "static/img/2023_9_8_10.260bc4bd.bf1289f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_10.260bc4bd.jpeg
// module id = i8zO
// module chunks = 0